import { RadioGroup, RadioItem } from './components';

export const Radio = {
  Group: RadioGroup,
  Item: RadioItem,
};
